import React from 'react'
import {connect} from 'react-redux'
import {Chart} from 'react-google-charts';
import {formatarReal} from '../../util/numberUtil';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';


export class GraficoPorEmpresaAgencia extends React.Component {


    tooltip(item) {
        return '<div class="google-visualization-tooltip-item"><strong style="font-size: 16px";">' + capitalizarTodasPrimeirasLetras(item.nome) + '</strong><br/>' +
            '<span style="font-size: 16px"> (Representa=):  <strong>' + item.porcentagemVendas + '%</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Aprov=):  <strong>' + item.quantidadeVendas + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (Q.Canc =):  <strong>' + item.quantidadeCancelamentos + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (T.Faturado=):  <strong>' + formatarReal(item.valorTotalVendas.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (V.Cancelado=):  <strong>' + formatarReal(item.valorTotalCancelamentos.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (F.Liquid R$=):  <strong>' + formatarReal(item.valorTotalVendasLiquido.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (I.liquid R$=):  <strong>' + formatarReal(item.valorTotalImposto.toString()) + '</strong></span><br/>' +
            '<span style="font-size: 16px"> (L. Comissão=):  <strong>' + formatarReal(item.valorTotalComissao.toString()) + '</strong></span></div>'

    }

    executarDownload(arquivo, agenciaHabilitado) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        if(agenciaHabilitado) {
            a.download = 'VexBi - Faturamento por Agência.csv';
        } else {
            a.download = 'VexBi - Faturamento por Empresa.csv';            
        }

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarGraficoPorEmpresaAgencia() {
        let arquivo = '';
        let retorno = '';
                
        if(this.props.agenciaHabilitado) {
            retorno = this.props.vexadoBI.totalFaturamentoPorAgencia
            arquivo += 'Agência;'            
        } else {
            retorno = this.props.vexadoBI.totalFaturamentoPorEmpresa
            arquivo += 'Empresa;'
        }

        arquivo += 'Representação de porcentagem;Q. Aprov;Q. Cancelada;T. Faturado;V. Cancelado;F. Liquido; Imposto Líquido; L. Comissão\n';

        arquivo = `${arquivo}${retorno.map(it => {
            let valor = '';
            const valorTotalVendas = it.valorTotalVendas.toString().replace('.', ',')
            const valorTotalCancelamentos = it.valorTotalCancelamentos.toString().replace('.', ',')
            const valorTotalVendasLiquido = it.valorTotalVendasLiquido.toString().replace('.', ',')
            const valorTotalImposto = it.valorTotalImposto.toString().replace('.', ',')
            const valorTotalComissao = it.valorTotalComissao.toString().replace('.', ',')
            const empresa = capitalizarTodasPrimeirasLetras(it.nome);

            valor += `${empresa};${it.porcentagemVendas};${it.quantidadeVendas};"${it.quantidadeCancelamentos}";"${valorTotalVendas}";"${valorTotalCancelamentos}";"${valorTotalVendasLiquido}";"${valorTotalImposto}";"${valorTotalComissao}"`
            return valor;
        }).join('\n')}\n`;

        this.executarDownload(arquivo, this.props.agenciaHabilitado)
    }

    render() {
        const retorno = [];
        retorno.push(['Rota', 'Valor', {
            role: 'tooltip',
            type: 'string',
            p: {html: true}
        }]);
        if (this.props.agenciaHabilitado) {            
            this.props.vexadoBI.totalFaturamentoPorAgencia.forEach((it) => retorno.push([capitalizarTodasPrimeirasLetras(it.nome), it.porcentagemVendas, this.tooltip(it)]));
        } else {
            this.props.vexadoBI.totalFaturamentoPorEmpresa.forEach((it) => retorno.push([capitalizarTodasPrimeirasLetras(it.nome), it.porcentagemVendas, this.tooltip(it)]));
        }

        return <React.Fragment>
            <Chart
                chartType="PieChart"
                data={retorno}
                options={{
                    title: `Faturamento por ${this.props.agenciaHabilitado ? 'agência' : 'empresa'} `,
                    tooltip: {trigger: 'selection', isHtml: true},
                }}
                width={'100%'}
                height={this.props.full ? '800px' : '400px'}
                chartEvents={[
                    {
                        eventName: 'ready',
                        callback: ({chartWrapper, google}) => {
                            const chart = chartWrapper.getChart();
                            google.visualization.events.addListener(chart, 'onmouseover', function (entry) {
                                chart.setSelection([{row: entry.row}]);
                            });

                            google.visualization.events.addListener(chart, 'onmouseout', function () {
                                chart.setSelection([]);
                            });
                        }
                    }
                ]}
            />
            {this.props.full ? null : <button className="input-group-text bg-white btn-campo-busca float-right"
                                            onClick={() => this.props.expandir('empresaAgencia')}>Expandir</button>}
            {this.props.full ? null : <button className="input-group-text btn-laranja btn-campo-busca float-right exportar"
                                            onClick={() => this.exportarGraficoPorEmpresaAgencia()}>Exportar Lista</button>}    
        </React.Fragment>
    }
}

export function mapStateToProps(state) {
    return {
        vexadoBI: state.vexadoBI
    }
}

export default connect(mapStateToProps, {})(GraficoPorEmpresaAgencia)
